export default __webpack_public_path__ + "static/media/hotelgift_logos.dff7f674.png";